import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _typeof from "@babel/runtime-corejs3/helpers/typeof";
//@ts-nocheck
import { useState, useEffect } from "react";
export default function useWindowSize() {
  var isClient = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object";
  function getSize() {
    return {
      innerWidth: isClient ? window.innerWidth : undefined,
      innerHeight: isClient ? window.innerHeight : undefined,
      outerWidth: isClient ? window.outerWidth : undefined,
      outerHeight: isClient ? window.outerHeight : undefined
    };
  }
  var _useState = useState(getSize),
    _useState2 = _slicedToArray(_useState, 2),
    windowSize = _useState2[0],
    setWindowSize = _useState2[1];
  useEffect(function () {
    if (!isClient) {
      return false;
    }
    function handleResize() {
      setWindowSize(getSize());
    }
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, [getSize, isClient]); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
}